import React from 'react'
import FilterTagsPc from '../FilterTags/FilterTagsPc';
import { SelectProps } from 'antd';

export interface GoodsTagsPcProps extends SelectProps {
    tagType?:'goods'
}

function FilterGoodsTagsPc(props:GoodsTagsPcProps) {
    const { tagType='goods', ...rest } = props;
    return <FilterTagsPc
    placeholder={'商品标签'}
    tagType={tagType} 
    {...rest}
    />
}

export default FilterGoodsTagsPc